import { render } from "./CardUserDetail.vue?vue&type=template&id=5c4d83a9&scoped=true&ts=true"
import script from "./CardUserDetail.vue?vue&type=script&lang=ts"
export * from "./CardUserDetail.vue?vue&type=script&lang=ts"

import "./CardUserDetail.vue?vue&type=style&index=0&id=5c4d83a9&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4d83a9"]])

export default __exports__